/**
 * Lottery Execution Summary class that is part of the lottery
 */
export class LotteryExecutionSummary {
  public '@id': string;
  public numberOfRequestedTickets: number;
  public numberOfRequests: number;
  public priceCategoryCapacity: number;
  public priceCategoryId: string;
  public selectedPriceCategories: Array<string> = [];

  constructor(priceReduction: any) {
    this['@id'] = priceReduction['@id'];
    this.numberOfRequestedTickets = priceReduction.numberOfRequestedTickets ?? 0;
    this.numberOfRequests = priceReduction.numberOfRequests ?? 0;
    this.priceCategoryCapacity = priceReduction.priceCategoryCapacity ?? 0;
    this.priceCategoryId = priceReduction.priceCategoryId;
    this.selectedPriceCategories = priceReduction.selectedPriceCategories;
  }
}

/**
 * Lottery Execution results class that is part of the lottery
 */
export class LotteryExecutionResults {
  public '@id': string;
  public id: number;
  public numberOfWinners: number;
  public numberOfDrawnTickets: number;
  public priceCategoryCapacity: number;

  constructor(executionResults: any, iterationId: number) {
    this['@id'] = executionResults['@id'];
    this.id = iterationId;
    this.numberOfWinners = executionResults.numberOfWinners ?? 0;
    this.numberOfDrawnTickets = executionResults.numberOfDrawnTickets ?? 0;
    this.priceCategoryCapacity = executionResults.priceCategoryCapacity ?? 0;
  }
}
